import { Directive, ElementRef, Input, Renderer2, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appLoading]', // Directive selector
  standalone: true,
})
export class LoadingDirective implements OnChanges {
  @Input() appLoading: boolean = false; // Input for controlling loading state
  @Input() loaderHeight: string = '100%'; // Input for specifying loader height
  private loaderElement: HTMLElement | null = null;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appLoading']) {
      if (this.appLoading) {
        this.showLoader();
      } else {
        this.hideLoader();
      }
    }
  }

  private showLoader(): void {
    if (!this.loaderElement) {
      // Create loader div
      this.loaderElement = this.renderer.createElement('div');
      this.renderer.addClass(this.loaderElement, 'directive-loader');

      // Set loader height dynamically
      this.renderer.setStyle(this.loaderElement, 'height', this.loaderHeight);

      // Create span element 
      const loaderSpan = this.renderer.createElement('div');
      this.renderer.setAttribute(loaderSpan, 'class', 'directive-loader-img');
      this.renderer.appendChild(this.loaderElement, loaderSpan);

      // Append loader to the host element
      this.renderer.appendChild(this.el.nativeElement, this.loaderElement);
    }
  }

  private hideLoader(): void {
    if (this.loaderElement) {
      this.renderer.removeChild(this.el.nativeElement, this.loaderElement);
      this.loaderElement = null;
    }
  }
}
